import { gql, useMutation } from '@apollo/client'

export const CREATE_LABEL_TEMPLATE = gql`
  mutation ($input: CreateLabelTemplate) {
    createLabelTemplate(input: $input) {
      id
    }
  }
`

export const useCreateLabelTemplate = () => {
  const [mutate, { data, loading, error }] = useMutation(CREATE_LABEL_TEMPLATE, {
    update(cache) {
      cache.modify({
        fields: {
          getLabelTemplates() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
